"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initTealiumSsr = initTealiumSsr;
exports.initTealium = void 0;
var _tealiumTracker = _interopRequireDefault(require("tealium-tracker"));
var _deepClone = _interopRequireDefault(require("deep-clone"));
var _dataLayer = require("./data-layer");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var initTealium = function initTealium(_ref) {
  var siteData = _ref.siteData,
    schema = _ref.schema,
    applyRules = _ref.applyRules;
  var debugMode = false;
  try {
    debugMode = localStorage.getItem("tealiumDebugMode") === "true";
  } catch (e) {// Handles following exception thrown from incognito iframe, ok with no debugging
    // DOMException: Failed to read the 'localStorage' property from 'Window': Access is denied for this document.
  }
  var tealiumTracker = (0, _tealiumTracker["default"])({
    schema: schema,
    debugMode: debugMode
  });
  var applyRulesWithClone = applyRules ? function (data) {
    return applyRules((0, _deepClone["default"])(data));
  } : function (data) {
    return data;
  };
  var _trackEvent = function trackEvent(data, applyRules) {
    tealiumTracker.trackEvent((0, _dataLayer.getDataLayer)(data, applyRules));
  };
  return {
    siteData: siteData,
    inject: {
      trackEvent: function trackEvent(data) {
        return _trackEvent(data, applyRulesWithClone);
      },
      getTrackingQueryString: function getTrackingQueryString(data) {
        return (0, _dataLayer.getTrackingQueryString)(data, applyRulesWithClone);
      },
      trackEventAndStoreTrafficSource: function trackEventAndStoreTrafficSource(data) {
        _trackEvent(data, applyRulesWithClone);
        (0, _dataLayer.storeTrafficSource)(data, applyRulesWithClone);
      },
      getAnalyticsId: function getAnalyticsId(data) {
        return (0, _dataLayer.getAnalyticsId)(data, applyRulesWithClone);
      }
    },
    onPageLoad: function onPageLoad(data) {
      tealiumTracker.trackPageLoad((0, _dataLayer.getDataLayer)(data, applyRules));
    }
  };
};
exports.initTealium = initTealium;
function initTealiumSsr(_ref2) {
  var siteData = _ref2.siteData,
    applyRules = _ref2.applyRules;
  var applyRulesWithClone = applyRules ? function (data) {
    return applyRules((0, _deepClone["default"])(data));
  } : function (data) {
    return data;
  };
  return {
    siteData: siteData,
    inject: {
      getTrackingQueryString: function getTrackingQueryString(data) {
        return (0, _dataLayer.getTrackingQueryString)(data, applyRulesWithClone);
      },
      getAnalyticsId: function getAnalyticsId(data) {
        return (0, _dataLayer.getAnalyticsId)(data, applyRulesWithClone);
      }
    }
  };
}